export default "__VITE_ASSET__Dz1NCnNV__"